/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-container[_ngcontent-%COMP%]{position:relative;height:100vh;overflow-y:scroll}.header[_ngcontent-%COMP%]{height:105px;max-height:105px;padding:15px}.logoLink[_ngcontent-%COMP%]{background:url(logo.4f84991b827de5c3147a.svg) 0 0/contain no-repeat;display:block;width:100%;height:100%}.versionIdentifier[_ngcontent-%COMP%]{position:fixed;right:12px;bottom:2px;height:12px;font-size:8px;color:#999;text-align:right}\n/*# sourceMappingURL=main.component.css.map*/"];
export { styles as styles };
